import request from '@/utils/request'
// 获取资讯列表
export function getNewsList (query) {
  return request({
    url: '/consult/article/query',
    method: 'get',
    params: query
  })
}
// 获取资讯列表详情
export function getNewsListDetail (query) {
  return request({
    url: '/consult/article/get',
    method: 'get',
    params: query
  })
}
// 获取轮播图右边  往期回顾
export function getReview (query) {
  return request({
    url: '/review/query',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/news.js